import React from 'react';
import { Modal, Button } from 'antd';

import FormConfig from 'components/Form/Form.config';

// const getExpiration = (expirationDate, expirationDateDynamic = '30') => {
//   if (!expirationDate) {
//     return (
//       <div>
//         Sans réponse de notre service Accueil et
//         Biodiversité dans un délai de {expirationDateDynamic} jours, cet
//         accusé réception aura valeur d'autorisation
//         pour votre manifestation de moins de 60 personnes maximum
//       </div>
//     );
//   }
//   const date = (expirationDate.split('-')).reverse();
//   const [day, month, year] = date;
//   return (
//     <div>ONF s'engage à vous repondre avant le {day}/{month}/{year}</div>
//   );
// };

const SuccessModal = ({ visible, handleAction }) => (
  <Modal
    visible={visible}
    title={FormConfig.confirmation.modal.title}
    closable={false}
    footer={[
      <Button key="submit" type="primary" onClick={() => handleAction()}>
        {FormConfig.confirmation.modal.action}
      </Button>,
    ]}
  >
    {FormConfig.confirmation.modal.text}
    {/* Temporary deactivation of this feature https://gitlab.makina-corpus.net/Clients/onf/issues/176
    getExpiration(expirationDate, expirationDateDynamic) */}
  </Modal>
);

export default SuccessModal;



// WEBPACK FOOTER //
// ./src/components/Form/SuccessModal.js